import * as React from 'react'

import Dashboard from '@material-ui/icons/Dashboard'
import Person    from '@material-ui/icons/Person'

import {
  EditPersonalInformation,
}                                              from '../components/environments'
import App                                     from '../components/environments/App'
import { Routing, SubRouting } from '../types'
import ProgramRouting                          from './ProgramRouting'

const dashboardRouting: SubRouting = [
  {
    name:      'programs',
    path:      '/programs',
    component: ProgramRouting,
  },
]

const profileRouting: SubRouting = [
  {
    name:      'personal',
    path:      '/personal',
    component: EditPersonalInformation,
  }
]

const routing: Routing = [
  {
    name:       'dashboard',
    path:       '/dashboard',
    icon:       <Dashboard />,
    subrouting: dashboardRouting,
  },
  {
    name:       'profile',
    path:       '/profile',
    icon:       <Person />,
    subrouting: profileRouting,
  },
]

export default () => <App routing={routing} />



// WEBPACK FOOTER //
// ./src/routing/Mentor.tsx